import { render } from "./LandscapingClinicsView.vue?vue&type=template&id=f21079ac&scoped=true"
import script from "./LandscapingClinicsView.vue?vue&type=script&lang=js"
export * from "./LandscapingClinicsView.vue?vue&type=script&lang=js"

import "./LandscapingClinicsView.vue?vue&type=style&index=0&id=f21079ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21079ac"]])

export default __exports__